import { useContext, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import { updateOptimiserSettings } from '../../../api/Optimise';
import { AppContext } from '../../../context/AppContext';
import Toggle from '../../Toggle';

import InformationPanel from './InformationPanel';

const SelfConsumptionModeSettings = ({ loadOptimiserSettings, setShowError }) => {
  const theme = useTheme();
  const { optimiserSettings, setOptimiserSettings, userSub } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!!optimiserSettings) {
      setIsLoading(false);
    }
  }, [optimiserSettings]);

  const handleSwitchChange = async (newState) => {
    setIsSaving(true);
    await updateOptimiserSettings(
      {
        battery_options: { self_consumption_mode: newState },
      },
      userSub
    )
      .then(() => {
        setOptimiserSettings((prev) => {
          const previousSettings = prev ?? {};
          const previousBatteryOptions = previousSettings.battery_options ?? {};
          return {
            ...previousSettings,
            battery_options: {
              ...previousBatteryOptions,
              self_consumption_mode: newState,
            },
          };
        });
      })
      .catch((e) => {
        console.error(e);
        setShowError(true);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const switchOn = Boolean(optimiserSettings?.battery_options?.self_consumption_mode);

  return (
    <InformationPanel title="Self-consumption mode">
      <li>
        {theme.language.brandName}'s default mode optimises for cash savings. Self-consumption mode enables your home to
        rely more on your battery and less on the grid during off peak times. This will lead to slightly smaller
        savings.
        <Toggle switchOn={switchOn} isLoading={isLoading} isSaving={isSaving} handleSwitchChange={handleSwitchChange} />
      </li>
    </InformationPanel>
  );
};

export default SelfConsumptionModeSettings;
